export const setReferralParams = (params) => ({
  type: 'SET_REFERRAL_PARAMS',
  payload: params,
})
